import { h } from 'preact';

// Variant objects ({ name, md5, date }) have no id and no hex value, so the
// pill value is the variant name — the same value the old <select> stored at
// runtime and the value the image scroller matches on.
const toggleVariant = (current, name) => (current === name ? '' : name);

const VariantPills = ({ title, options = [], selected, onSelect = () => {} }) => {
    if (!options || options.length < 1) {
        return null;
    }
    return (
        <div class='d-flex flex-column w-100 align-items-center mb-2'>
            <div class='fw-bold mb-1'>
                {selected
                    ? <i class='fa-solid fa-circle-check text-success me-2' />
                    : <i class='fa-solid fa-triangle-exclamation text-warning me-2' />}
                {title}
            </div>
            <div class='d-flex flex-row flex-wrap justify-content-center gap-2'>
                {options.map(opt => {
                    const isSelected = selected === opt.name;
                    return (
                        <button
                            type='button'
                            key={opt.name}
                            class={`btn ${isSelected ? 'btn-primary' : 'btn-outline-secondary'} rounded-pill`}
                            onClick={() => onSelect(opt.name)}
                        >
                            {isSelected && <i class='fa-solid fa-check me-1' />}
                            {opt.name}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export { toggleVariant };
export default VariantPills;
